module.exports = __webpack_public_path__ + "media/images/top/feature/top-features-2-f7608e2cddfb3e6c9bab0b26ed7a3d34.png";